import type { WidgetSettings, WidgetSize } from './widget-types.ts';

type TrendSettings = WidgetSettings<'trend'>;
type BreakdownSettings = WidgetSettings<'breakdown'>;
type TopSettings = WidgetSettings<'topProducts'>;

export const TREND_MEASURES = [
  'sales',
  'created',
  'confirmed',
  'delivered',
  'returned',
  'canceled',
] as const satisfies readonly TrendSettings['measure'][];
export const TREND_CHARTS = ['line', 'area', 'columns'] as const satisfies readonly TrendSettings['chart'][];
export const BREAKDOWN_DIMENSIONS = [
  'carrier',
  'governorate',
  'source',
  'status',
] as const satisfies readonly BreakdownSettings['dimension'][];
export const BREAKDOWN_MEASURES = [
  'orders',
  'delivered',
  'returned',
  'sales',
  'deliveryRate',
] as const satisfies readonly BreakdownSettings['measure'][];
const BREAKDOWN_CHARTS = [
  'stacked',
  'grouped',
  'line',
  'barList',
  'donut',
] as const satisfies readonly BreakdownSettings['chart'][];
export const TOP_PRODUCT_CHARTS = ['barList', 'donut'] as const satisfies readonly TopSettings['chart'][];
export const WIDGET_SIZE_CHOICES = ['sm', 'md', 'lg', 'full'] as const satisfies readonly WidgetSize[];

const PART_OF_WHOLE_CHARTS: ReadonlySet<string> = new Set(['stacked', 'donut']);

export const chartsForMeasure = (
  measure: BreakdownSettings['measure'],
): readonly BreakdownSettings['chart'][] =>
  measure === 'deliveryRate'
    ? BREAKDOWN_CHARTS.filter((chart) => !PART_OF_WHOLE_CHARTS.has(chart))
    : BREAKDOWN_CHARTS;

export const withMeasure = (
  settings: BreakdownSettings,
  measure: BreakdownSettings['measure'],
): BreakdownSettings => {
  const charts = chartsForMeasure(measure);
  return { ...settings, measure, chart: charts.includes(settings.chart) ? settings.chart : 'line' };
};
